<template>
  <div>
    <v-checkbox
      :key="props.id"
      :id="props.field"
      :data-cy="props.id.split('_')[1] + '-' + props.field"
      v-bind="$attrs"
      ref="inputField"
      v-model="stringValue"
      role="CalcInput"
      hide-details
      :readonly="readonly"
      false-value="0"
      true-value="1"
      @change="onChange"
      @keydown="isNumber">
          <template #append  v-if="authStore.isSuperUser">
                <math-tooltip :name="props.field" :title="$t(`entities.${elementType}.fields.${field}`)"/>
              </template>
    </v-checkbox>
  </div>
</template>

<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { computed, toRef } from "vue";
import { useMainStore } from "@/stores/mainStore";
import { useCalcInput } from "./calcInputComposable";
import { useAuthStore } from "@/stores/authStore";
import MathTooltip from "./MathTooltip.vue";


const copyName = () => {
  navigator.clipboard.writeText(`,"${props.field}"`);
};


const authStore = useAuthStore();
const mainStore = useMainStore();

const props = withDefaults(
  defineProps<{
    id: string;
    field: string;
    type: "text" | "number";
    readonly: boolean;
    icon: string | null;
  }>(),
  {
    type: "text"
  }
);

const [_, elementType] = props.id.split("_");

function onChange() {
  console.log(
    "Checkbox value changed",
    inputField.value,
    inputField.value.$el,
    inputField.value.$el.blur
  );
  // inputField.value && inputField.value.blur();

  // inputField.value?.$el?.blur();
  watchFocus(true);
  watchFocus(false);
}

const stringValue = computed({
  get() {
    return value.value?.toString();
  },
  set(newValue) {
    value.value = newValue;
  }
});

const { inputField, watchFocus, value, isNumber, readonly } = useCalcInput(
  toRef(() => props.id),
  toRef(() => props.field),
  props.readonly,
  props.type
);
</script>
